export default "__VITE_ASSET__k9w_OmWH__"